import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const isDevelopmentRegionEditor = import.meta.env.DEV
    && location.pathname === '/mining-map'
    && new URLSearchParams(location.search).get('regionEditor') === '1';

  if (isDevelopmentRegionEditor) {
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-start pt-[30vh]">
        <div className="w-full flex justify-center">
          <img
            src="https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt/public/image/logo/bbg_token.png"
            alt="Loading"
            className="w-20 h-20 animate-spin"
            style={{ animation: 'spin 2s linear infinite' }}
          />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
